export default "__VITE_ASSET__CWlAJg5O__"